var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFriesSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96918 16.6142C2.73918 16.6142 2.55251 16.8008 2.55251 17.0308C2.55251 17.2608 2.73918 17.4475 2.96918 17.4475L17.0308 17.4492C17.2608 17.4492 17.4475 17.2625 17.4475 17.0325C17.4475 16.8025 17.2608 16.6158 17.0308 16.6158L2.96918 16.6142Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96912 9.58333C2.73912 9.58333 2.55245 9.76999 2.55245 9.99999C2.55245 10.23 2.73912 10.4167 2.96912 10.4167L11.3024 10.4175C11.5324 10.4175 11.7191 10.2308 11.7191 10.0008C11.7191 9.77083 11.5324 9.58416 11.3024 9.58416L2.96912 9.58333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96918 2.55167C2.73918 2.55167 2.55251 2.73833 2.55251 2.96833C2.55251 3.19833 2.73918 3.385 2.96918 3.385L17.0308 3.38583C17.2608 3.38583 17.4475 3.19917 17.4475 2.96917C17.4475 2.73917 17.2608 2.5525 17.0308 2.5525L2.96918 2.55167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFriesSvgrepoCom1);
export default __webpack_public_path__ + "static/media/menu-fries-svgrepo-com 1.174a9c66b8bcbf3f6822cd29c12b7704.svg";
export { ForwardRef as ReactComponent };